import { c as _c } from "react/compiler-runtime";
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Trans, useTranslation } from 'next-i18next/pages';
import { ReactElement } from 'react';
interface ResourceHeadingProps {
  heading: string;
}
const StyledSpan = styled('span')({
  background: 'linear-gradient(90deg, #0D7DE5 0%, #E02BAD 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  textFillColor: 'transparent'
});
export function ResourceHeading(t0) {
  const $ = _c(6);
  const {
    heading
  } = t0;
  const {
    t
  } = useTranslation("apps-watch");
  const t1 = `${heading} for every `;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <StyledSpan>interaction</StyledSpan>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = <Typography variant="h4">{t1}{t2}</Typography>;
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t || $[4] !== t3) {
    t4 = <Trans t={t}>{t3}</Trans>;
    $[3] = t;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}